import Marquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const items = [
  "Admissions Open",
  "26+ Years of Excellence",
  "100% Result-Oriented Teaching",
  "Limited Batch Size",
];

export default function AnnouncementMarquee() {
  return (
    <div
      data-testid="announcement-marquee"
      className="w-full border-y border-red-700/40 bg-red-600 text-white"
    >
      <Marquee
        speed={42}
        gradient={false}
        pauseOnHover
        autoFill
        className="py-2.5 md:py-3"
      >
        {items.map((text, i) => (
          <span
            key={i}
            className="mx-6 flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] md:mx-10 md:text-[13px]"
          >
            <Sparkles className="h-3.5 w-3.5 text-orange-200" />
            {text}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
